import {
    FETCH_CREATE_COMMONS_CAPACITIES_REQUEST,
    FETCH_CREATE_COMMONS_CAPACITIES_SUCCESS,
    FETCH_CREATE_COMMONS_CAPACITIES_FAILURE,
} from '../../actions/commonsCapacities/create-commonsCapacities-action';

const initialState = {
    createdCommonCapacities: null,
    isLoading: false,
    error: null,
};

const CLEAR_DATA = "CLEAR_DATA";
const CreateCommonCapacitiesReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case FETCH_CREATE_COMMONS_CAPACITIES_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case FETCH_CREATE_COMMONS_CAPACITIES_SUCCESS:
            return {
                ...state,
                isLoading: false,
                createdCommonCapacities: { ...action.payload[0] },
            };
        case FETCH_CREATE_COMMONS_CAPACITIES_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };
        case CLEAR_DATA:
            return {
                ...initialState
            };
        default:
            return state;
    }
};

export default CreateCommonCapacitiesReducer;